(function () {
  'use strict';
  var root = document.querySelector('[data-bundle-route]');
  if (!root) return;
  try {
    var config = JSON.parse(root.querySelector('[data-bundle-route-config]').textContent);
    if (config.unavailable) {
      var requested = window.location.pathname.replace(/\/$/, '');
      var prefix = new URL(config.rootUrl || '/', window.location.origin).pathname.replace(/\/$/, '') + '/products/';
      var handle = requested.indexOf(prefix) === 0 ? requested.slice(prefix.length) :
        requested.indexOf('/products/') === 0 ? requested.slice('/products/'.length) : '';
      var offers = {
        'two-hardcover-stories': 'two-stories',
        'two-hardcover-stories-uk': 'two-stories',
        'six-hardcover-stories': 'complete-collection',
        'six-hardcover-stories-uk': 'complete-collection',
        // Read & Colour is retired: its old links go to the collection.
        'three-stories-three-colouring-books': 'complete-collection',
        'three-stories-three-colouring-books-uk': 'complete-collection'
      };
      if (!Object.prototype.hasOwnProperty.call(offers, handle)) return;
      config.offer = offers[handle];
      root.hidden = false;
    }
    var params = new URLSearchParams(window.location.search);
    var from = params.get('from');
    var path = Object.prototype.hasOwnProperty.call(config.stories, from) ? config.stories[from] : config.defaultUrl;
    var target = new URL(path, window.location.origin);
    if (target.origin !== window.location.origin || !/\/products\//.test(target.pathname)) return;
    target.searchParams.set('bundle', config.offer);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'msclkid'].forEach(function (key) {
      if (params.has(key)) target.searchParams.set(key, params.get(key));
    });
    root.querySelector('[data-bundle-route-link]').href = target.href;
    window.location.replace(target.href);
  } catch (error) { /* The ordinary journey link remains usable. */ }
}());
